import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import Form, { useForm } from '../../components/useForm';
import ServiceButtonWithToast from '../_common/ServiceButtonWithToast';
import SymptomDropdown from './SymptomDropdown';

const initialFieldValues = {
  symptomId: '',
};
export default function SymptomSelector(props) {
  const {
    onSuccess, handleSymptomAdd, buttonText, successMsg,
  } = props;

  const {
    values,
    errors,
    setErrors,
    handleInputChange,
  } = useForm(initialFieldValues);

  // Function to check if the selected input is valid
  const isValidInput = () => {
    const errorMsg = {};
    errorMsg.symptom = values.symptomId === '' ? 'Please select a symptom.' : '';
    setErrors({ ...errorMsg });
    return Object.values(errorMsg).every((item) => item === '');
  };

  const handleButtonClick = async () => {
    if (isValidInput()) {
      return handleSymptomAdd(values.symptomId); // Return the promise
    }
    return null;
  };

  return (
    <Form>
      <Grid container>
        <Grid item xs={10}>
          <SymptomDropdown
            label="Select a Symptom"
            name="symptomId"
            value={values.symptomId}
            onChange={handleInputChange}
            error={errors.symptom}
          />
          <ServiceButtonWithToast
            service={handleButtonClick}
            onSuccess={onSuccess}
            buttonText={buttonText}
            successMsg={successMsg}
          />
        </Grid>
      </Grid>
    </Form>
  );
}

SymptomSelector.propTypes = {
  onSuccess: PropTypes.func,
  handleSymptomAdd: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
  successMsg: PropTypes.string.isRequired,
};

SymptomSelector.defaultProps = {
  onSuccess: null,
};
